import type { DeepPartial, Theme } from '@chakra-ui/react';
import { baseTheme } from '@chakra-ui/react';

/** extend additional color here */
const extendedColors: DeepPartial<
  Record<string, Theme['colors']['blackAlpha']>
> = {};

/** override chakra colors here */
const overiddenChakraColors: DeepPartial<Theme['colors']> = {};

export const colors = {
  ...baseTheme.colors,
  ...overiddenChakraColors,
  ...extendedColors,
};
